export default __webpack_public_path__ + "static/media/searchexperts_mobile.d9133d80.svg";